<i18n>
{
  "en": {
    "title": "Outreach Sustainability Report 2017-2018",
    "description": "Learn how Schneider electric is innovating to solve the energy paradox with solar and green energy products, renewable resources, energy training, and strategic investing. a and the Schneider Electric Foundation help to reduce the energy gap and address fuel poverty for the millions who lack access to electricity.",
    "outreach": {
      "section": "&nbsp;",
      "title": "Outreach and Initiatives",
      "overview": {
        "quote1": {
          "para": "We want everyone on our planet to have access to safe, reliable, efficient, and sustainable energy, and we are committed to developing the innovations that will make this happen.",
          "name": "Gilles Vermot Desroches",
          "title": "Chief Sustainability Officer,",
          "company": "Schneider Electric"
        },
        "txtMedia1": {
          "title": "Innovation and engagement",
          "para1": "We believe that access to energy is a fundamental right. Today, approximately 1.1 billion people lack access to electricity.<sup>1</sup> But, as we expand access to energy, we all must be mindful of the effects of its consumption on the environment. We must be responsible toward people while remaining responsible toward the planet.",
          "para2-1": "At Schneider Electric, our solution to this energy paradox is twofold: innovation and engagement. Through our outreach and initiatives, we further support the ",
          "para2-2": " by deploying innovative business models and energy solutions to the world’s energy-poor communities. We promote entrepreneurship and engage others through training, funding, and volunteering to accelerate the world toward a healthier future for its people and its climate.",
          "para2-linkText": "U.N.’s Sustainable Development Goals"
        },
        "txt1": {
          "title": "The benefits of electricity",
          "listItem1": "Improved health, most significantly for women and children",
          "listItem2": "Reduced poverty and raised living standards",
          "listItem3": "Enhanced educational opportunities",
          "listItem4": "Strengthened environmental sustainability",
          "listItem5": "Improved security and feeling of safety",
          "listItem6": "Increased productivity"
        },
        "quote2": {
          "para": "By joining the Sustainable Energy for All partnership network, Schneider Electric is bringing their leadership to a movement that is focused on going further, faster &mdash; together &mdash; in closing the energy access gap.",
          "name": "Rachel Kyte,",
          "title": "CEO,",
          "company": "Sustainable Energy for All"
        },
        "vid1": {
          "title": "Access to Energy",
          "desc": "Gilles Vermot Desroches, Chief Sustainability Officer, Schneider Electric"
        },
        "references": {
          "referenceA": "<sup>1</sup> International Energy Agency, Energy Access Outlook 2017"
        }
      }
    }
  },
  "fr": {
    "title": "Outreach Sustainability Report 2017-2018",
    "description": "Learn how Schneider electric is innovating to solve the energy paradox with solar and green energy products, renewable resources, energy training, and strategic investing. a and the Schneider Electric Foundation help to reduce the energy gap and address fuel poverty for the millions who lack access to electricity.",
    "outreach": {
      "section": "&nbsp;",
      "title": "Initiatives et communautés",
      "overview": {
        "quote1": {
          "para": "Nous souhaitons que chaque personne dans le monde ait accès à une énergie sûre, fiable, efficace et durable, et nous sommes résolus à développer les innovations qui le permettront.",
          "name": "Gilles Vermot Desroches",
          "title": "Directeur Développement Durable,",
          "company": "Schneider Electric"
        },
        "txtMedia1": {
          "title": "Innovation et engagement",
          "para1": "Nous sommes convaincus que l’accès à l’énergie est un droit fondamental. À ce jour, 1,1 milliard de personnes n’ont pas accès à l’électricité. Toutefois, la généralisation de cet accès ne doit pas nous faire oublier les effets de la consommation d'électricité sur l’environnement. Notre responsabilité envers l’humanité doit aller de pair avec notre responsabilité envers la planète.",
          "para2-1": "Chez Schneider Electric, pour remédier à ce paradoxe énergétique, nous prônons une solution double : innovation et engagement. Dans le cadre de nos initiatives envers les communautés, nous déployons des solutions énergétiques et des modèles économiques innovants pour les populations en situation de précarité énergétique à travers le monde, et contribuons ainsi aux ",
          "para2-2": ". Nous promouvons l’entrepreneuriat et, par des actions de formation, de financement et de bénévolat, nous encourageons d’autres acteurs à faire évoluer le monde vers un avenir plus sain pour les êtres humains et le climat.",
          "para2-linkText": "Objectifs de Développement Durable de l’ONU"
        },
        "txt1": {
          "title": "Les avantages de l’électricité",
          "listItem1": "Amélioration de la santé, tout particulièrement pour les femmes et les enfants",
          "listItem2": "Réduction de la pauvreté et hausse du niveau de vie",
          "listItem3": "Meilleures opportunités sur le plan éducatif",
          "listItem4": "Plus grande viabilité environnementale",
          "listItem5": "Amélioration de la sûreté et du sentiment de sécurité",
          "listItem6": "Productivité accrue"
        },
        "quote2": {
          "para": "En rejoignant le partenariat Sustainable Energy for All, Schneider Electric apporte son savoir-faire à un mouvement conjoint visant à aller plus loin et plus vite pour réduire la fracture énergétique.",
          "name": "Rachel Kyte,",
          "title": "Directrice générale, ",
          "company": "Énergie durable pour tous"
        },
        "vid1": {
          "title": "Accès à l’énergie",
          "desc": "Gilles Vermot Desroches, Directeur Développement Durable, Schneider Electric"
        },
        "references": {
          "referenceA": "<sup>1</sup> Agence internationale de l’énergie, World Energy Outlook 2017"
        }
      }
    }
  }
}
</i18n>
<template>
  <div id="">
    <Hero :loResSrc="require('@/assets/img/homepage/outreach-low.jpg')" :hiResSrc="require('@/assets/img/homepage/outreach.jpg')" chapter="05" :section="$t('outreach.section')" :title="$t('outreach.title')" :grayBG="true" />

    <section class="m-b-120 m-t-120">
      <YouTubeVideo videoId="MmeoLSeOCQc" :title="$t('outreach.overview.vid1.title')" :description="$t('outreach.overview.vid1.desc')" :preview="require('@/assets/img/thumbnails/SSDHighlightVideo_GillesDesroches_Still.jpg')"/>
    </section>

    <section class="m-t-120 m-b-120">
      <Quote :photo="require('@/assets/img/outreach/Gilles_Vermot_Desroches_2017.jpg')" name="Gilles Vermot Desroches" :title="$t('outreach.overview.quote1.title')" company="Schneider Electric">
        <div v-html="$t('outreach.overview.quote1.para')"></div>
      </Quote>
    </section>

    <section class="m-b-120 m-t-120">
      <ImageFull class="m-b-80">
        <img :src="require('@/assets/img/outreach/Philippines2-Solar-lamp-library.jpg')" alt=""/>
      </ImageFull>

      <TxtMedia class="m-b-50">
        <div slot="main-content">
          <h2 id="innovationandengagement" v-html="$t('outreach.overview.txtMedia1.title')"/>
          <p v-html="$t('outreach.overview.txtMedia1.para1')"></p>
          <p class="m-b-32">
            <span v-html="$t('outreach.overview.txtMedia1.para2-1')"></span>
            <router-link class="t-green-light" v-html="$t('outreach.overview.txtMedia1.para2-linkText')" :to="{name: 'Introduction_SustainabilityAtSchneiderElectric', params: {lang: $route.params.lang }, hash: '#UN-Sustainabile-Development-Goals'}"></router-link>
            <span v-html="$t('outreach.overview.txtMedia1.para2-2')"></span>
          </p>
          <h3 v-html="$t('outreach.overview.txt1.title')"></h3>
          <ul>
            <li v-html="$t('outreach.overview.txt1.listItem1')"></li>
            <li v-html="$t('outreach.overview.txt1.listItem2')"></li>
            <li v-html="$t('outreach.overview.txt1.listItem3')"></li>
            <li v-html="$t('outreach.overview.txt1.listItem4')"></li>
            <li v-html="$t('outreach.overview.txt1.listItem5')"></li>
            <li v-html="$t('outreach.overview.txt1.listItem6')"></li>
          </ul>
        </div>
        <img slot="sidebar" src="@/assets/img/outreach/_82A2266_82A2266.jpg" />
      </TxtMedia>

      <Txt>

      </Txt>
    </section>

    <section class="m-t-120 m-b-120">
      <Quote :photo="require('@/assets/img/outreach/Rachel_Kyte_SustainableEnergyForAll.jpg')" name="Rachel Kyte" :title="$t('outreach.overview.quote2.title')" :company="$t('outreach.overview.quote2.company')">
        <div class="m-b-50" v-html="$t('outreach.overview.quote2.para')"></div>
        <img class="floating-logo" :src="require('@/assets/img/outreach/SEforALL_Delivery-Partner_Digital.png')" alt="">
      </Quote>
    </section>

    <section class="m-t-120 m-b-120">
      <div class="l-content">
        <div class="row">
          <div class="col-xs-16 col-xs-offset-1">
            <SvgContainer v-if="$i18n.locale === 'en'" id="electricitydeficit">
              <OROverviewIG class="scaling-svg" />
            </SvgContainer>
            <SvgContainer v-if="$i18n.locale === 'fr'" id="electricitydeficit">
              <OROverviewIGFR class="scaling-svg" />
            </SvgContainer>
          </div>
        </div>
      </div>
    </section>
    <References>
      <Reference v-html="$t('outreach.overview.references.referenceA')"/>
    </References>

    <div class="l-content">
      <FooterNav
        nextRoute="Outreach_AccessToEnergy"
        prevRoute="OurPeople_LiveLivesBetter" />
    </div>

  </div>
</template>

<script>
import FooterNav from '@/components/FooterNav'
import Hero from '@/components/Hero'
import Quote from '@/components/Quote'
import Statement from '@/components/Statement'
import FourCols from '@/components/FourCols'
import FourColsItem from '@/components/FourColsItem'
import CTA from '@/components/CTA'
import Txt from '@/components/Txt'
import References from '@/components/References'
import Reference from '@/components/Reference'
import YouTubeVideo from '@/components/YouTubeVideo'
import ImageFull from '@/components/ImageFull'
import TxtMedia from '@/components/TxtMedia'
import SvgContainer from '@/components/SvgContainer'

import OROverviewIG from '@/assets/img/ig/outreach-initiatives-overview.svg'
import OROverviewIGFR from '@/assets/img/ig/outreach-initiatives-overview_fr.svg'

export default {
  name: 'Outreach_Overview',
  metaInfo () {
    return {
      title: this.$t('title'),
      meta: [
        { name: 'description', content: this.$t('description') }
      ]
    }
  },
  mounted () {
    if (window.location.hash.substr(1).length > 0) {
      this.$nextTick(function () {
        document.getElementById(window.location.hash.substr(1)).scrollIntoView()
      })
    }
  },
  components: {
    FooterNav,
    Hero,
    Quote,
    Statement,
    FourCols,
    FourColsItem,
    CTA,
    Txt,
    References,
    Reference,
    YouTubeVideo,
    TxtMedia,
    ImageFull,
    SvgContainer,
    OROverviewIG,
    OROverviewIGFR
  }
}
</script>

<style>
.floating-logo {
  width: 160px;
}
</style>



// WEBPACK FOOTER //
// src/pages/outreach/overview.vue